const cardscontant = [
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Amazon",
    captionLower: "amazon",
    code: "62",
    color: "#020203",
    currency: "USD",
    data: "62|5:0.99,10:0.99,25:0.99,50:0.99,100:0.99,|USD",
    desc: "Amazon.com Gift Cards never expire and can be redeemed towards millions of items at www.Amazon.com, www.MyHabit.com, and certain of its affiliated websites. Amazon.com’s huge selection is the place to find and discover almost anything you want to buy online at a great price. Redeem at http://www.amazon.com/redeem. Valid only for U.S. Accounts.",
    disclosures: "",
    discount: 0.03,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFB22E",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/42887bd1.jpg",
    max_range: 100,
    min_range: 5,
    sendcolor: "#FFB436",
    value: "5,10,25,50,100",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Anniversary Birds",
    captionLower: "anniversary birds",
    code: "463",
    color: "#C21954",
    currency: "USD",
    data: "463|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/f265f66d.png",
    max_range: 250,
    min_range: 25,
    sendcolor: "#FFFFFF",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Birthday Special",
    captionLower: "birthday special",
    code: "459",
    color: "#FF2B75",
    currency: "USD",
    data: "459|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/6fb9653a.png",
    max_range: 250,
    min_range: 25,
    sendcolor: "#26F9FF",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "BlinkSky Wallet",
    captionLower: "blinksky wallet",
    code: "60",
    color: "#277549",
    currency: "USD",
    data: "60|25:2.99,50:2.99,100:2.99,250:2.99,500:2.99,1000:2.99,|USD",
    desc: "BlinkBux&#174; instantly load to your BlinkSky Wallet (USD only) and can be used anywhere BlinkSky Digital cards are accepted, simply scan the barcode. The perfect gift for any BlinkSky Wallet, BlinkBux Cards are great for wallet direct gifts fast, simple, convenient and always well-received.",
    disclosures: "",
    discount: 0,
    domain: "blinksky.com",
    fee: "2.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "*",
    logo: "https://blinksky.azureedge.net/5c581a5f.png",
    max_range: 1000,
    min_range: 25,
    sendcolor: "#FFFFFF",
    value: "25,50,100,250,500,1000",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Burger King",
    captionLower: "burger king",
    code: "146",
    color: "#8C6212",
    currency: "USD",
    data: "146|10:0.99,15:0.99,25:0.99,50:0.99,100:0.99,150:0.99,|USD",
    desc: "Every day, more than 11 million guests visit BURGER KING&#174; restaurants around the world. And they do so because our restaurants are known for serving high-quality, great-tasting, and affordable food. Founded in 1954, BURGER KING&#174; is the second largest fast food hamburger chain in the world. The original HOME OF THE WHOPPER&#174;, our commitment to premium ingredients, signature recipes, and family-friendly dining experiences is what has defined our brand for more than 50 successful years.",
    disclosures: "",
    discount: 0.0565,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/55bf39ad.jpeg",
    max_range: 150,
    min_range: 10,
    sendcolor: "#FFFFFF",
    value: "10,15,25,50,100,150",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Domino's",
    captionLower: "domino's",
    code: "102",
    color: "#296F96",
    currency: "USD",
    data: "102|5:0.99,10:0.99,15:0.99,20:0.99,25:0.99,30:0.99,35:0.99,50:0.99,80:0.99,100:0.99,|USD",
    desc: "The gift of pizza and so much more! Enjoy your favorite Pizza, Traditional Hand Tossed or Handmade Pan or a delicious variety of Specialty pizzas. Want more than pizza? Try one of three varieties of Stuffed Cheesy Bread, Oven Baked Sandwiches, Parmesan Bread Bites, or our Marbled Cookie Brownie and so much more. Redeem in-store: Present eGift Card. Redeem online: Order online at www.dominos.com.",
    disclosures: "",
    discount: 0.1,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/1aeb72ec.png",
    max_range: 100,
    min_range: 5,
    sendcolor: "#FFFFFF",
    value: "5,10,15,20,25,30,35,50,80,100",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Door Dash",
    captionLower: "door dash",
    code: "281",
    color: "#F2250A",
    currency: "USD",
    data: "281|15:0.99,20:0.99,25:0.99,30:0.99,40:0.99,50:0.99,75:0.99,100:0.99,125:0.99,200:0.99,|USD",
    desc: "Give a DoorDash eGift Card to someone who could use a good meal. This makes a great gift for birthdays, graduation and just about any holiday. It&#39;s a simple way to say &quot;Thank You&quot; to anyone! DoorDash eGift cards can be used online or for orders made in the mobile app. DoorDash delivers the best food from over 200,000 stores to people in over 1,500 cities. It&#39;s one of the easiest ways to order food online and have it delivered right to your door. DoorDash can deliver the goods when you need it. Order using your mobile app and DoorDash handles the rest.",
    disclosures: "",
    discount: 0.0504,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/e525ea0f.png",
    max_range: 200,
    min_range: 15,
    sendcolor: "#FFFFFF",
    value: "15,20,25,30,40,50,75,100,125,200",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "DUNKIN' DONUTS®",
    captionLower: "dunkin' donuts®",
    code: "260",
    color: "#E05F19",
    currency: "USD",
    data: "260|5:0.99,10:0.99,25:0.99,50:0.99,100:0.99,|USD",
    desc: "Dunkin&#39; Donuts offers great tasting food and beverages that will keep you running throughout your busy day. Refuel with our legendary coffee, or start your day with a hearty, satisfying breakfast sandwich. There are now more ways to satisfy your appetite than ever before, made to order just the way you like. The reloadable Dunkin&#39; Donuts Card is a convenient everyday way to pay for all your DD favorites and is accepted at any participating Dunkin&#39; Donuts restaurant.",
    disclosures: "",
    discount: 0.016,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/1d590faa.jpg",
    max_range: 100,
    min_range: 5,
    sendcolor: "#FFFFFF",
    value: "5,10,25,50,100",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Easter",
    captionLower: "easter",
    code: "433",
    color: "#E0DC6E",
    currency: "USD",
    data: "433|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#000000",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/65601056.jpg",
    max_range: 250,
    min_range: 25,
    sendcolor: "#D97979",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "eBay",
    captionLower: "ebay",
    code: "94",
    color: "#0F60A3",
    currency: "USD",
    data: "94|25:0.99,50:0.99,100:0.99,150:0.99,200:0.99,|USD",
    desc: "When you give an eBay gift card, you’re creating a world of possibilities for clients, coworkers, and the people you care about. That means whether they’re looking for something brand new, or just brand new to them, you give the easiest way to find it. And with billions of listings from over a million sellers, they can find the right item that’s right for them. Give the gift of all gifts today!",
    disclosures: "",
    discount: 0.0205,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FCFCFC",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/594db624.jpg",
    max_range: 200,
    min_range: 25,
    sendcolor: "#1E57AD",
    value: "25,50,100,150,200",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Employee Star",
    captionLower: "employee star",
    code: "437",
    color: "#90A302",
    currency: "USD",
    data: "437|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#000000",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/15e9b555.png",
    max_range: 250,
    min_range: 25,
    sendcolor: "#000000",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Father's Day",
    captionLower: "father's day",
    code: "330",
    color: "#000000",
    currency: "USD",
    data: "330|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/93f9e762.jpg",
    max_range: 250,
    min_range: 25,
    sendcolor: "#166CE0",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Instacart",
    captionLower: "instacart",
    code: "1489",
    color: "#23A13C",
    currency: "USD",
    data: "1489|25:1.99,50:1.99,75:1.99,100:1.99,250:1.99,|USD",
    desc: "Try Instacart to get the items you love delivered right to your doorstep.\r\nShop local stores in your neighborhood, Same-day delivery in as little as 2 hours, High-quality items, including produce and alcohol, Safe contactless delivery, Get exclusive coupons and savings.",
    disclosures: "",
    discount: 0.06,
    domain: "blinksky.com",
    fee: "1.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/ee277bb4.png",
    max_range: 250,
    min_range: 25,
    sendcolor: "#000000",
    value: "25,50,75,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Mastercard World",
    captionLower: "mastercard world",
    code: "1402",
    color: "#3089C9",
    currency: "USD",
    data: "1402|25:7.99,50:7.99,100:7.99,250:7.99,500:7.99,1000:7.99,|USD",
    desc: "Use your U.S. MasterCard Rewards card at U.S. merchants wherever you see the Mastercard Acceptance Mark online or over the phone. Use your card online or over the phone wherever you see the Mastercard Acceptance Mark. Valid US address required.",
    disclosures: "",
    discount: 0,
    domain: "blinksky.com",
    fee: "7.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "*",
    logo: "https://blinksky.azureedge.net/ba69ff3b.png",
    max_range: 1000,
    min_range: 25,
    sendcolor: "#000000",
    value: "25,50,100,250,500,1000",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Mother's Day Thanks",
    captionLower: "mother's day thanks",
    code: "430",
    color: "#D97873",
    currency: "USD",
    data: "430|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "BlinkSky Blinkables take the guesswork out of gifting. Send BlinkSky Blinkables to family, friends, employees, customers, or prospects. It’s the perfect gift for all occasions — Your recipients can choose from Amazon™, eBay&#174;, Target™, Best Buy™, Walmart&#174; or any of the hundreds of e-Gift Cards in our catalog.",
    disclosures: "",
    discount: 25,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/76117e64.jpg",
    max_range: 250,
    min_range: 25,
    sendcolor: "#804D41",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Nike",
    captionLower: "nike",
    code: "108",
    color: "#E63300",
    currency: "USD",
    data: "108|10:0.99,25:0.99,50:0.99,100:0.99,150:0.99,250:0.99,|USD",
    desc: "From sports fans to style freaks. From trendsetters to goal setters. From competitors to comfort-lovers. Nike Gift Cards are the optimal way to celebrate the greatness in us all. With Nike Gift Cards, you&#39;re giving limitless potential. One gift opens a complete collection of performance footwear, apparel, accessories, and equipment – from one of the most iconic brands in the world. REDEEM IN STORE: Present at any one of our stores to redeem for merchandise. REDEEM ONLINE: www.nike.com.",
    disclosures: "",
    discount: 0.05,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/a1dbaab0.png",
    max_range: 250,
    min_range: 10,
    sendcolor: "#FFFFFF",
    value: "10,25,50,100,150,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Papa John’s",
    captionLower: "papa john’s",
    code: "192",
    color: "#9E0000",
    currency: "USD",
    data: "192|10:0.99,25:0.99,50:0.99,100:0.99,|USD",
    desc: "Papa John&#39;s takes pride in providing a menu that&#39;s prepared with only the finest ingredients. Combine our total commitment to quality with our superior ingredients, and the result is pure pizza excellence! REDEEM ONLINE: Simply go to www.papajohns.com to place your order. REDEEM IN RESTAURANT: Present your digital gift card on phone to redeem. REDEEM BY PHONE: Provide the team member taking your order with your 19-digit gift card number and 4-digit PIN.",
    disclosures: "",
    discount: 0.1,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#E6E6E6",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/7406e3d1.png",
    max_range: 250,
    min_range: 25,
    sendcolor: "#000000",
    value: "10,25,50,100",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Pizza Hut Restaurants",
    captionLower: "pizza hut restaurants",
    code: "1282",
    color: "#020202",
    currency: "GBP",
    data: "1282|10:0.79,15:0.79,25:0.79,50:0.79,75:0.79,100:0.79,250:0.79,|GBP",
    desc: "Whether it’s a birthday prezzie, a family celebration or just to say thank you, cheers, ta… You get the picture. Give someone the gift that gives again – a Pizza Hut Restaurants Gift Card! eGift Card can be used in any participating Pizza Hut Restaurant.",
    disclosures: "",
    discount: 0.1,
    domain: "blinksky.co.uk",
    fee: "0.79",
    fontcolor: "#FFFFFF",
    is_variable: true,
    iso: "gb",
    logo: "https://blinksky.azureedge.net/5693aa24.png",
    max_range: 250,
    min_range: 10,
    sendcolor: "#FAF9F9",
    value: "10,15,25,50,75,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Spotify",
    captionLower: "spotify",
    code: "729",
    color: "#36CD7B",
    currency: "USD",
    data: "729|10:0.99,30:0.99,60:0.99,|USD",
    desc: "With Spotify, it’s easy to find the right music for every moment – on your phone, your computer, your tablet and more. There are millions of tracks on Spotify. So whether you’re working out, partying or relaxing, the right music is always at your fingertips. Choose what you want to listen to, or let Spotify surprise you. You can also browse through the music collections of friends, artists and celebrities, or create a radio station and just sit back. Soundtrack your life with Spotify. Valid only for U.S. Accounts.",
    disclosures: "",
    discount: 0.03,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/4c64aac5.jpg",
    max_range: 60,
    min_range: 10,
    sendcolor: "#000000",
    value: "10,30,60",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Starbucks",
    captionLower: "starbucks",
    code: "43",
    color: "#105E14",
    currency: "USD",
    data: "43|5:0.99,10:0.99,25:0.99,|USD",
    desc: "Treat yourself – or someone else – to something special at Starbucks with a Starbucks Card. Use it towards premium coffee, tea, refreshers, lunch, pastries and more. If you register your Starbucks Card with the Starbucks Rewards™ loyalty program, you can get even more free food and drinks.",
    disclosures: "",
    discount: 0.05,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/736daa87.jpg",
    max_range: 25,
    min_range: 5,
    sendcolor: "#FFFFFF",
    value: "5,10,25",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "TripGift®",
    captionLower: "tripgift®",
    code: "239",
    color: "#D53884",
    currency: "USD",
    data: "239|25:0.99,50:0.99,100:0.99,250:0.99,|USD",
    desc: "If you have been waiting for your next vacation or Experience Day out, let TripGift&#174; help you! The International Award winning TripGift&#174; offers the world’s best Gift card and eCommerce selection for worldwide Travel, Experience Days &amp; Digital Media with a truly unique choice to redeem for 450 Airlines, 600,000 Hotels, Villas &amp; Apartments, 50,000 Experience Days, 2,000 Tours, 16 Cruise Lines, 500 Car Rental Providers, 140 eLanguage courses all with one Gift card which you can use to book instantly via online and mobile.",
    disclosures: "",
    discount: 0.04,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/10213af9.jpg",
    max_range: 250,
    min_range: 25,
    sendcolor: "#E43078",
    value: "25,50,100,250",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "UBER",
    captionLower: "uber",
    code: "197",
    color: "#000000",
    currency: "USD",
    data: "197|15:0.99,20:0.99,25:0.99,30:0.99,40:0.99,50:0.99,60:0.99,80:0.99,100:0.99,200:0.99,|USD",
    desc: "Gift Uber rides to the people you care about, or add value to your Uber account. The Uber app connects you to a reliable ride in minutes. From low-cost to premium, every option feels like an upgrade to the everyday. And payment is automatic—no cash, no card, no hassle. Redeem eGift Card in the Uber or UberEATS app.",
    disclosures: "",
    discount: 0.031,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/796b4acf.png",
    max_range: 200,
    min_range: 15,
    sendcolor: "#000000",
    value: "15,20,25,30,40,50,60,80,100,200",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Uber UK",
    captionLower: "uber uk",
    code: "609",
    color: "#000000",
    currency: "GBP",
    data: "609|15:0.79,25:0.79,50:0.79,100:0.79,150:0.79,|GBP",
    desc: "Gift Uber rides to the people you care about, or add value to your Uber account. The Uber app connects you to a reliable ride in minutes. From low-cost to premium, every option feels like an upgrade to the everyday. And payment is automatic—no cash, no card, no hassle.",
    disclosures: "",
    discount: 0.05,
    domain: "blinksky.co.uk",
    fee: "0.79",
    fontcolor: "#FFFFFF",
    is_variable: true,
    iso: "gb",
    logo: "https://blinksky.azureedge.net/796b4acf.png",
    max_range: 150,
    min_range: 15,
    sendcolor: "#000000",
    value: "15,25,50,100,150",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "UberEATS",
    captionLower: "ubereats",
    code: "382",
    color: "#000000",
    currency: "USD",
    data: "382|15:0.99,20:0.99,25:0.99,30:0.99,40:0.99,50:0.99,60:0.99,80:0.99,100:0.99,200:0.99,|USD",
    desc: "Get the food you want, from the restaurants you love, delivered at Uber speed. UberEATS works with over a hundred restaurants in your city to put great local food all in one place. If you’re craving it, you can find it on UberEATS. By tapping into the Uber network, you can get anything from our roster of local restaurants, fast.  \r\nSafe Pickups, Low-cost and Premium Options, Ratings Ensure Premium Quality, Cashless Payment.",
    disclosures: "",
    discount: 0.031,
    domain: "blinksky.com",
    fee: "0.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/53a34266.png",
    max_range: 200,
    min_range: 15,
    sendcolor: "#000000",
    value: "15,20,25,30,40,50,60,80,100,200",
  },
  {
    __type: "Giftcard:#",
    __type: "item",
    caption: "Walmart",
    captionLower: "walmart",
    code: "110",
    color: "#0B3C8C",
    currency: "USD",
    data: "110|5:1.99,10:1.99,25:1.99,50:1.99,100:1.99,250:1.99,|USD",
    desc: "With a Walmart eGift Card, you get low prices every day on thousands of popular products in stores or online at Walmart.com and Samsclub.com.&#160;\r\nSee&#160;www.walmart.com/giftcardtermsandconditions for complete gift card terms and conditions.",
    disclosures: "",
    discount: 0.007,
    domain: "blinksky.com",
    fee: "1.99",
    fontcolor: "#FFFFFF",
    is_variable: false,
    iso: "us",
    logo: "https://blinksky.azureedge.net/f8638a2b.png",
    max_range: 250,
    min_range: 5,
    sendcolor: "#FFFFFF",
    value: "5,10,25,50,100,250",
  },
];

export default cardscontant;
